import * as symbols from "@/assets/plugins/mps-common/symbols";

export default function () {
    Object.prototype[symbols.isEmpty] = function () {
        return Object.keys(this).length === 0;
    };
}